import React from 'react';

import { observer } from 'mobx-react';
import { reverse } from 'named-urls';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';
import routes from 'core/routes';
import { useStore } from 'utils/hooks/store';
import { TemplateListResponse } from 'utils/api/modules/workflows/workflows.types';

const FormTemplatesActionCell: React.FC<{
  rowData: TemplateListResponse;
}> = ({ rowData }) => {
  const { routing, templateDetails } = useStore();

  const actions: ActionConfig[] = [
    {
      id: 'edit-button',
      label: 'Edit',
      onClick: () => {
        routing.push(reverse(routes.dashboard.audits.templates.details, { templateId: rowData.uuid }));
      },
    },
    {
      id: 'duplicate-button',
      label: 'Duplicate',
      onClick: () => templateDetails.duplicateTemplate(rowData.uuid),
    },
  ];

  return <ActionCell actions={actions} recordName={rowData.name} />;
};

export default observer(FormTemplatesActionCell);
